// extracted by mini-css-extract-plugin
export var productImage = "_qn-1";
export var viewLink = "_qn-2";
export var wishlistItem = "_qn-0";